export const groupsWithOrganizerAccess = [
  'event-admin',
  'event-judge',
  'orga-admin'
];
